import { useState, useCallback, useEffect } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useFetchUserTrailers() {
    const { uid } = useFirebaseAuth();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const fetchTrailers = useCallback(
        async () => {
            if (!uid) return;
            setLoading(true);
            setError(null);
            setSuccess(false);

            try {
                const response = await API.get(`/users/${uid}/trailers`);
                setData(response.data);
                setSuccess(true);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        },
        [uid]
    )

    useEffect(() => {
        if (uid) {
            fetchTrailers();
        }
    }, [uid, fetchTrailers]);

    return { data, fetchTrailers, loading, error, success };
}
